<template>
  <div>
    <div class="hero section-type-s bground-config-clean presentation">
      <div>
        <Banner :random="randomData"></Banner>
        <div class="row section-type-c">
          <CarCard
            buttonText="Ver catálogo"
            contents="Felix Agencia Automotriz se ocupará de todas tus necesidades para asegurarte el mejor servicio."
            :urlImage="url1"
            title="Autos nuevos"
            url="/autosnuevoschevrolet"
          ></CarCard>
          <CarCard
            buttonText="Ver catálogo"
            contents="Felix Agencia Automotriz se ocupará de todas tus necesidades para asegurarte el mejor servicio."
            :urlImage="url2"
            title="Autos seminuevos"
            url="/autosseminuevoschevrolet"
          ></CarCard>
          <CarCard
            buttonText="Más información"
            contents=" Tu seguridad es lo más importante para nosotros, por eso contamos con los mejores especialistas para el cuidado de tu Chevrolet"
            :urlImage="url3"
            title="Servicios de reparación"
          ></CarCard>
        </div>
      </div>
    </div>
    <div class="section-type-a pt-5 pb-5 presentation">
      <div class="personal-container">
        <div class="mb-64">
          <h1 class="text-center text-light">Consulta nuestro catálogo</h1>
          <h5 class="text-center text-light">
            Con las promociones y planes de financiamiento que Felix Agencia
            Automotriz tiene para ti: ¡Siente la emoción de estrenar!
          </h5>
        </div>
        <div class="row section-type-c car-search justify-content-center">
          <div class="col-12 car-results">
            <div class="row no-gutters">
              <!--Otro aqui. Aqui va el tablero de coches-->
              <CocheCard
                v-bind:key="`${coche.idVehiculo}-suc-${coche.sucursal}`"
                v-for="coche in coches"
                :id="`${coche.idVehiculo}`"
                :urlBackgroundImage="coche.portada"
                :carModel="coche.nombre"
                :stock="1"
                :releaseYear="coche.nombre"
                :initialPayment="coche.contado"
                :monthlyCost="coche.mensualidad"
                :colors="coche.colores"
              ></CocheCard>
              <!--iterar aquiiii-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-type-a pt-5">
      <div class="personal-container">
        <div class="mb-32">
          <h1 class="text-center pt-2">Grupo Felix</h1>
          <h2 class="text-center mb-64">Conoce nuestro blog</h2>
        </div>
        <div class="row section-type-c mb-32">
          <BlogEntrance
            v-bind:key="bl.idArticulo"
            v-for="bl in blog"
            :portada="bl.portada"
            :titulo="bl.titulo"
            :descripcion="bl.descripcion"
            :contenido="bl.contenido"
            :id="bl.idArticulo"
            :fecha="bl.descripcion"
          ></BlogEntrance>
        </div>
      </div>
    </div>
    <div
      class="section-type-c pb-5 mb-32 position-relative bground-config-clean"
      :style="{ backgroundImage: `url('${testimonialImage}')` }"
    >
      <div class="personal-container advertisements">
        <div class="mb-32 pt-5">
          <h1
            class="text-center text-light position-relative"
            style="z-index: 10"
          >
            Testimonios de nuestros clientes
          </h1>
        </div>
        <div class="row section-type-c">
          <div class="owl-carousel carousel-principal-testimonials">
            <Testimonial
              vehicleText="CHEVROLET TRAVERSE"
              vehicleImage="https://northwest.ams3.digitaloceanspaces.com/grupofelix/vehicles/d37bd6f3fd3b1c16c5436d8ea22a91e8"
              client="Nayelli Oropeza "
              title="Excelente Grupo, te tratan de la mejor manera. Un súper servicio al cliente y con el auto en sus talleres de servicio."
            ></Testimonial>
            <Testimonial
              vehicleText="CHEVROLET TRAVERSE"
              vehicleImage="https://northwest.ams3.digitaloceanspaces.com/grupofelix/vehicles/d37bd6f3fd3b1c16c5436d8ea22a91e8"
              client="Nayelli Oropeza "
              title="Excelente Grupo, te tratan de la mejor manera. Un súper servicio al cliente y con el auto en sus talleres de servicio."
            ></Testimonial>
            <Testimonial
              vehicleText="CHEVROLET TRAVERSE"
              vehicleImage="https://northwest.ams3.digitaloceanspaces.com/grupofelix/vehicles/d37bd6f3fd3b1c16c5436d8ea22a91e8"
              client="Nayelli Oropeza "
              title="Excelente Grupo, te tratan de la mejor manera. Un súper servicio al cliente y con el auto en sus talleres de servicio."
            ></Testimonial>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Banner from "@/components/Banner";
import CarCard from "@/components/CarCard";
import CocheCard from "@/components/CocheCard";
import BlogEntrance from "@/components/BlogEntrance";
import Testimonial from "@/components/Testimonial";

export default {
  name: "Home",
  components: {
    // Navbar
    Banner,
    CarCard,
    CocheCard,
    BlogEntrance,
    Testimonial,
  },
  data() {
    return {
      url1: require("@/assets/images/corvette-exterior-v2.webp"),
      url2: require("@/assets/images/pexels-simon-migaj-1571783.jpeg"),
      url3: require("@/assets/images/srr.png"),
      testimonialImage: require("@/assets/images/pexels-steven-arenas-379419.jpg"),
      coches: [],
      blog: [],
      randomData: [],
      initialBlogs: 3,
      vehiculosRemoteApi: [],
      vehiculosApiLocal: [],
      STATUS: "1",
      sucursal: "",
    };
  },
  async mounted() {
    window.addEventListener("sucursal-changed", async (event) => {
      this.mapData();
    });
    await this.getAllData();
  },
  destroyed() {
    window.removeEventListener("sucursal-changed", async (event) => {
      this.mapData();
    });
  },
  methods: {
    async viewMoreBlog() {
      this.initialBlogs += 3
      const articulos = await this.$http.get(`${this.API_URL}/web/blogs/all?page=1&limit=${this.initialBlogs}`)
      this.blog = articulos.data.data.elementos
    },
    async getAllData() {
      await this.getDataLocalAPIRandom();
      await this.getCatalogo();
      await this.getBlog();

      // const vehiculosLocalStorage = JSON.parse(localStorage.getItem('vehiculos-globaldms-api'))

      // if (vehiculosLocalStorage) {
      //   this.vehiculosRemoteApi = vehiculosLocalStorage
      //   this.mapData()
      // }

      // await this.getCarsGlobalDmsApi()
      this.mapData();
    },
    async getDataLocalAPIRandom() {
      const responseLocalAPI = await this.$http.get(
        `${this.API_URL}/web/vehicles/random`
      );
      this.randomData = responseLocalAPI.data.data;
    },
    async getCarsGlobalDmsApi() {
      const vehiculos = await this.$http.get("/globaldms/vehiculos.asp");
      this.vehiculosRemoteApi = vehiculos.data;

      localStorage.setItem(
        "vehiculos-globaldms-api",
        JSON.stringify(this.vehiculosRemoteApi)
      );
    },
    async getCatalogo() {
      const vehiculos = await this.$http.get(
        this.API_URL +
          "/web/vehicles/catalogo?page=1&limit=12&idSucursal=" +
          localStorage.getItem("suc")
      );
      this.vehiculosApiLocal = vehiculos.data.data.elementos;
    },
    async getBlog() {
      const articulos = await this.$http.get(
        `${this.API_URL}/web/blogs/all?page=1&limit=${this.initialBlogs}`
      );
      this.blog = articulos.data.data.elementos;
    },
    mapData() {
      // let apiCars = {}
      // apiCars = this.vehiculosApiLocal.reduce((acc, car) => {
      //   acc[car.vehiculo_id] = car
      //   return acc
      // }, {})

      if (parseInt(localStorage.getItem("suc"))) {
        const vehiculosWhereSucursal = this.vehiculosApiLocal.filter(
          (car) => car.sucursal_id === parseInt(localStorage.getItem("suc"))
        );

        this.coches = vehiculosWhereSucursal;
      } else {
        this.coches = this.vehiculosApiLocal;
      }

      /*this.coches = vehiculosWhereSucursal.map(car => {
        return {
          ...car,
          contado: apiCars[car.idVehiculo] ? apiCars[car.idVehiculo].contado : '0',
          mensualidad: apiCars[car.idVehiculo] ? apiCars[car.idVehiculo].mensualidad : '0',
          portada: apiCars[car.idVehiculo] ? apiCars[car.idVehiculo].portada : '',
          id: apiCars[car.idVehiculo] ? apiCars[car.idVehiculo].idVehiculo : '',
        }
      }).filter(car => car.portada !== '' && car.mensualidad > 0 && car.contado > 0)*/
    },
  },
};
</script>
